import { StyledTooltip } from './style';
import { CSSProperties, ReactNode, useEffect, useState } from 'react';
import TooltipPortal from 'components/portal/TooltipPortal/TooltipPortal';
import { getTranslation } from 'utils/translation';
import { Icons } from 'contents/icons';

export type TooltipDirectionType =
  | 'top'
  | 'top-left'
  | 'top-right'
  | 'bottom'
  | 'bottom-left'
  | 'bottom-right'
  | 'right'
  | 'right-top'
  | 'right-bottom'
  | 'left'
  | 'left-top'
  | 'left-bottom';

export interface TooltipProps {
  parentRef?: React.RefObject<HTMLElement>;
  direction: TooltipDirectionType;
  label: string | ReactNode;
  noPermission?: boolean;
  disabledMessage?: string;
  wordWrap?: boolean;
  maxWidth?: string;
  noMaxWidth?: boolean; // 일부 화면에서 너비를 제한하지 않아야 하는 부분이 있어 추가
  parentGap?: string; // 툴팁과 부모 요소 사이의 간격
  type?: 'normal' | 'strong';
}

export const Tooltip = ({
  parentRef,
  direction,
  label,
  noPermission,
  disabledMessage,
  wordWrap = true,
  maxWidth,
  noMaxWidth = false,
  parentGap = '0.7rem',
  type = 'strong',
}: TooltipProps) => {
  const [parentBoxRect, setParentBoxRect] = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0,
  });

  useEffect(() => {
    if (parentRef?.current) {
      const rect = parentRef.current.getBoundingClientRect();
      setParentBoxRect(rect);
    }
  }, []);

  const TooltipRender = ({ style }: { style?: CSSProperties }) => {
    return (
      <StyledTooltip
        direction={direction}
        $wordWrap={wordWrap}
        $noMaxWidth={noMaxWidth}
        $maxWidth={maxWidth}
        $parentGap={parentGap}
        $type={type}
        className="tooltip-box"
        style={style}
      >
        <Icons.Polygon1 className="tail" />
        {typeof label === 'string' ? (
          <p className="label">
            {label}
            {noPermission && !disabledMessage && (
              <span className="disabled">{getTranslation('message', 'ERROR.NO_PERMISSION')}</span>
            )}
            {disabledMessage && !noPermission && (
              <span className="disabled">{disabledMessage}</span>
            )}
          </p>
        ) : (
          label
        )}
      </StyledTooltip>
    );
  };

  if (parentRef) {
    return (
      <TooltipPortal>
        <div
          className="parent-box"
          style={{
            pointerEvents: 'none',
            position: 'absolute',
            width: parentBoxRect.width + 'px',
            height: parentBoxRect.height + 'px',
            left: parentBoxRect.left + 'px',
            top: parentBoxRect.top + 'px',
          }}
        >
          <TooltipRender />
        </div>
      </TooltipPortal>
    );
  }

  return <TooltipRender />;
};
